import { sound } from "@pixi/sound";
import { Application, Assets, Container, TextureSource } from "pixi.js";
import { getManifest } from '../config/assets';
import { getManifestMobile } from "../config/assetsMobile";
import { getMobileDetect } from "../config/GlobalVariableConfig";
import { Banner } from "../scene/Banner";
import { IntroScene } from "../scene/IntroScene";
import { LoaderScene } from '../scene/LoaderScene';
import { PerformanceProfiler } from "../utils/PerformanceProfiler";
import { BurgerMenuManager } from "./burgerMenuManager";
import { CasinoChannelHandler, casinoEventEmitter } from "./CasinoChannelHandler";

declare const globalThis: any;


// declare const window: any;
// const hacksaw = window.hacksawCasino;
// const casinoChannel = hacksaw.PubSub.getChannel('casino');

// let _betAcceptedToken: any;

export class Manager {

    private constructor() { } //no use
    private static app: Application;
    private static currentScene: IScene;

    public static loder: LoaderScene;
    private static intro: IntroScene;

    public static banner: Banner | null = null;

    public static screenwidth: number;
    public static screenHeight: number;

    private static last: number = 0;
    private static targetFPS: number = 60;
    private static interval: number = 1000 / Manager.targetFPS;

    // public static get width(): number {
    //     return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    // }
    // public static get height(): number {
    //     return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    // }

    static casinoChannelHandler = new CasinoChannelHandler();
    static burgerMenuManager = new BurgerMenuManager();
    public static Orientation: "LANDSCAPE" | "PORTRAIT" = "LANDSCAPE";

    public static async initialize(background: string): Promise<void> {

        document.getElementById('webgl').style.display = "none";

        Manager.app = new Application();

        globalThis.__PIXI_APP__ = Manager.app;

        TextureSource.defaultOptions.autoGarbageCollect = true;
        // Intialize the application.
        await Manager.app.init({
            resizeTo: window,
            width: window.innerWidth,
            height: window.innerHeight,
            backgroundColor: background,
            resolution: window.devicePixelRatio || 1,
            autoDensity: true,
            failIfMajorPerformanceCaveat: false,
            // antialias: true,
        });

        // Manager.app.renderer._roundPixels = 1;

        // console.log("Manager.app.renderer._roundPixels", Manager.app.renderer._roundPixels);

        // Then adding the application's canvas to the DOM body.
        document.getElementById('GameWrapper')?.appendChild(Manager.app.canvas);

        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.overflow = 'hidden';
        document.body.style.width = '100%';
        document.body.style.height = '100%';

        // document.body.style.width = `${window.innerWidth}px`;
        // document.body.style.height = `${window.innerHeight}px`;

        // const perf = new PerformanceManager(Manager.app);


        // Manager.app.canvas.autod


        // Add marker div used by e2e test to identify game is ready to interact with (preloader complete)
        const preloadIndicator = document.createElement('div');
        preloadIndicator.id = 'PreloadIndicator';
        document.body.appendChild(preloadIndicator);

        // Manager.app.ticker.add(Manager.update)
        Manager.app.ticker.add(() => {
            PerformanceProfiler.update();
            this.last += Manager.app.ticker.deltaMS;
            if (this.last < this.interval) return;
            this.last -= this.interval; // we can use this.last = 0;  been suggested this.last -= this.interval; as improvement 
            Manager.update();

        });


        // Page Visibility API to pause and resume the game
        window.addEventListener('visibilitychange', Manager.handleVisibilityChange);
        // window.addEventListener('blur', Manager.pauseSound);
        // window.addEventListener('focus', Manager.resumeSound);


        /******************* */


        CasinoChannelHandler.reportGameReady();

        // Return a promise that resolves when 'initGameReady' is triggered
        await new Promise<void>((resolve) => {
            casinoEventEmitter.removeAllListeners('initGameReady');
            casinoEventEmitter.once('initGameReady', () => {
                console.log('Game is ready!');
                resolve(); // Resolve the promise when the event is triggered
            });
        });




        // setTimeout(() => {
        //     CasinoChannelHandler.reportGameReady();

        //     CasinoChannelHandler.reportGameLoaded() // here the circle-loader will diappear? but it looks like on 

        // }, 0)

        // Manager.subscribeToCasinoMessages();

        // setTimeout(() => {
        //     CasinoChannelHandler.reportGameReady();

        //     CasinoChannelHandler.reportGameLoaded() // here the circle-loader will diappear? but it looks like on 

        // }, 5000)

        /************************ */
        Manager.resize(window.innerWidth, window.innerHeight);

        window.addEventListener("resize", () => {
            // Manager.resize(window.innerWidth, window.innerHeight);
            if (Manager.loder) {
                Manager.resize(window.innerWidth, window.innerHeight);
                Manager.loder.resize(window.innerWidth, window.innerHeight);
            }
        });

        casinoEventEmitter.on('scaleResize', () => {
            // console.log('scaleResize', data);    
            Manager.resize(window.innerWidth, window.innerHeight);
        });
        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", () => {
                Manager.resize(window.innerWidth, window.innerHeight);
            });
            window.visualViewport.addEventListener("scroll", () => {
                Manager.resize(window.innerWidth, window.innerHeight);
            });
        }

        // casinoChannel.subscribe('scaleResize', (data: any) => {
        //     console.log('scaleResize', data);
        //     Manager.resize(window.innerWidth, window.innerHeight);
        // });
        const manifestDesktop = getManifest();
        const manifestMobile = getManifestMobile();
        const manifest = getMobileDetect() ? manifestMobile : manifestDesktop;
        console.log(getMobileDetect() ? "Mobile manifest loaded" : "Desktop manifest loaded");
        await Assets.init({ manifest: manifest });

        // extract the bundle names into an array.
        const bundleNames = manifest.bundles.map(b => b.name);
        // Bundles can be loaded in the background too!
        await Assets.backgroundLoadBundle(bundleNames);

        // Manager.reportGameLoaded()

        sound.disableAutoPause = true;

    }


    private static handleVisibilityChange(): void {
        if (document.hidden) {
            sound.pauseAll();
        } else {
            sound.resumeAll();
        }

    }

    // private static awaitUserInteraction(callback: () => void): void {
    //     const resumeHandler = () => {
    //         callback();
    //         window.removeEventListener('click', resumeHandler);
    //         window.removeEventListener('touchstart', resumeHandler);
    //     };

    //     // Listen for the next user interaction
    //     window.addEventListener('click', resumeHandler);
    //     window.addEventListener('touchstart', resumeHandler);
    // }

    // private static pauseSound(): void {
    //     sound.volumeAll = 0;
    // }

    // private static resumeSound(): void {
    //     sound.volumeAll = 1;
    // }


    public static resize(screenwidth: number, screenHeight: number): void {

        Manager.screenwidth = screenwidth;
        Manager.screenHeight = screenHeight;
        Manager.app.renderer.resize(screenwidth, screenHeight);
        if (screenwidth > screenHeight) {
            Manager.Orientation = "LANDSCAPE";
        }
        else {
            Manager.Orientation = "PORTRAIT";
        }

        // console.log(`manager resize screenWidth${screenwidth} screenHeight ${screenHeight}`);

        // if we have a scene, we let it know that a resize happened!
        if (Manager.currentScene) {
            Manager.currentScene.resize(screenwidth, screenHeight);
        }

        if (Manager.loder) {
            Manager.loder.resize(screenwidth, screenHeight);
        }

        if (Manager.intro) {
            Manager.intro.resize(screenwidth, screenHeight);
        }


        if (Manager.banner) {
            Manager.banner.resize(screenwidth, screenHeight);
        }
    }

    // Call this function when you want to go to a new scene
    // Call this function when you want to go to a new scene
    public static async changeScene(newScene: IScene, displayLoder: boolean): Promise<void> {

        // Remove and destroy old scene... if we had one..
        if (Manager.currentScene) {
            Manager.app.stage.removeChild(Manager.currentScene);

            // FIX 1: Set texture to false. Let PIXI.Assets manage GPU memory.
            Manager.currentScene.destroy({ children: true, texture: false });
            Manager.currentScene = null;
        }
        // SpineSymbolPool.clear();
        Manager.app.renderer.textureGC.run();
        await new Promise(requestAnimationFrame);

        if (displayLoder) {
            console.log("inside displayLoder");

            Manager.loder = new LoaderScene();
            await Manager.loder.showInitLogo(window.innerWidth, window.innerHeight);
            Manager.app.stage.addChild(Manager.loder);

            // Now, let's start downloading the assets we need and wait for them...
            // Pixi will gracefully skip loading if textures weren't manually destroyed above.
            await Assets.loadBundle(newScene.assetBundles, Manager.loder.downloadProgress);
            console.log("asset load done");

            CasinoChannelHandler.reportGameLoaded();

            //create a banner scene
            Manager.banner = new Banner(Manager.screenwidth, Manager.screenHeight);
            Manager.intro = new IntroScene();
            await Manager.intro.showInitLogo(window.innerWidth, window.innerHeight);
            Manager.app.stage.addChild(Manager.intro);

            Manager.app.stage.removeChild(Manager.loder);

            // FIX 2: Set texture to false for the LoaderScene as well
            Manager.loder.destroy({ children: true, texture: false });
            Manager.loder = null;

            Manager.intro.on('pointerup', () => {
                Manager.intro.off('pointerup');

                newScene.constructorWithAssets();
                Manager.currentScene = newScene;
                Manager.app.stage.addChild(Manager.currentScene);

                //banner will always be on top of game scenes
                Manager.app.stage.addChild(Manager.banner);

                Manager.intro.endTileAnimation();

                Manager.app.stage.removeChild(Manager.intro);

                // FIX 3: Safe destruction of intro container
                Manager.intro.destroy();
                Manager.intro = null;

                Manager.resize(window.innerWidth, window.innerHeight);
            })

        }
        else {
            await Assets.loadBundle(newScene.assetBundles);
            newScene.constructorWithAssets();

            Manager.currentScene = newScene;
            Manager.app.stage.addChild(Manager.currentScene);

            //banner will always be on top of game scenes
            Manager.app.stage.addChild(Manager.banner);
            Manager.resize(window.innerWidth, window.innerHeight);
        }
    }

    // This update will be called by a pixi ticker and tell the scene that a tick happened
    private static update(): void {
        if (Manager.currentScene) {
            Manager.currentScene.update();
        }

        if (Manager.intro) {
            Manager.intro.update()
        }

        if (Manager.banner) {
            Manager.banner.update()
        }

    }
}

export interface IScene extends Container {
    update(): void;

    // we added the resize method to the interface
    resize(screenWidth: number, screenHeight: number): void;

    constructorWithAssets(): void
    // constructorWithAssets(promise: Promise<unknown>): void

    assetBundles: string[];
}